/* Якорь для попапа меню (AccountMenu.module.css) — тот же приём, что у
   истории снимков (sync/SnapshotControls.module.css). */
.box {
  position: relative;
  display: inline-flex;
  flex: none;
}

.label {
  max-width: 14ch;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account {
  gap: var(--sp-3);
}

/* Точка у имени — единственный намёк на неподтверждённую почту в тулбаре:
   подробности живут в кабинете и в полосе под тулбаром. */
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--warn);
  flex: none;
}

.placeholder {
  display: inline-block;
  width: 84px;
  height: var(--ctl-h);
}
